import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) return <div className="pt-40 text-center text-qbfg/40">Checking access…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
